module.exports = __webpack_public_path__ + "img/logo.3bcfb4f5.svg";